import React from 'react';
import * as ethicalInboxAdminService from '../../../services/ethical-inbox/admin/EthicalInbox';
const EthicalInboxAdminContext = React.createContext();
const { Provider, Consumer } = EthicalInboxAdminContext;

class EthicalInboxAdminProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.exportReports = this.exportReports.bind(this);
    this.edit = this.edit.bind(this);
    this.deleteReport = this.deleteReport.bind(this);
    this.sendResponse = this.sendResponse.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxAdminService
        .home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async exportReports(data) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxAdminService
        .exportReports(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async edit(id) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxAdminService
        .edit(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async deleteReport(id) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxAdminService
        .deleteReport(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async sendResponse(data) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxAdminService
        .sendResponse(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          edit: this.edit,
          deleteReport: this.deleteReport,
          exportReports: this.exportReports,
          sendResponse: this.sendResponse,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default EthicalInboxAdminContext;

export { EthicalInboxAdminProvider, Consumer };
